import React from 'react';
import { Router, IndexRoute, Route } from 'react-router'
import { history } from '../store';

// Layouts
import PrimaryLayout from "../layouts/primary/primary-layout.jsx";
// Views
import HomeView from "../views/home-view/home-view.jsx"

export default function getRoutes() {
    return (
        <Router history={history}>
            <Route path="/" component={PrimaryLayout}>
                <IndexRoute component={HomeView} />
            </Route>
        </Router>
    );
}



/** WEBPACK FOOTER **
 ** ./app/routes/routes.jsx
 **/